// extracted by mini-css-extract-plugin
module.exports = {"Form":"Form_Form__1lAKg","container":"Form_container__3RG8m","error-input":"Form_error-input__2HgaX","error-text":"Form_error-text__2xRkO"};